import { ScrollView } from 'react-native';
import { Colors, Flex, Typography, useScreenSize } from '@banhala/ui-kit';
import { useMyPersonalizationSizeAtoms } from '../../state';
import { useAtom, useSetAtom } from 'jotai';
import { useProductCategories } from '../../queries/useProductCategories';
import { useCallback, useRef } from 'react';

export const StandardCategoryTabBar = () => {
  const { selectedProductCategoryGroupAtom, selectedProductCategoryAtom } =
    useMyPersonalizationSizeAtoms();
  const [selectedGroup, setSelectedGroup] = useAtom(
    selectedProductCategoryGroupAtom,
  );
  const setSelectedProductCategory = useSetAtom(selectedProductCategoryAtom);

  const { data: groups } = useProductCategories();
  const { width: containerWidth } = useScreenSize();

  const scrollRef = useRef<ScrollView>(null);
  /**각 tabItem의 좌표값을 보관하고  스크롤 시 중앙에 위치하도록 스크롤 */
  const itemLayoutsRef = useRef<Map<number, { x: number; width: number }>>(
    new Map(),
  );

  const scrollToCenter = useCallback(
    (sno: number) => {
      const layout = itemLayoutsRef.current.get(sno);
      if (!layout) return;
      const targetX = layout.x + layout.width / 2 - containerWidth / 2;
      scrollRef.current?.scrollTo({ x: Math.max(0, targetX), animated: true });
    },
    [containerWidth],
  );

  const handleSelectStandardCategory = useCallback(
    (standardCategorySno: number) => {
      const found = groups.find(
        g => g.standard_category_sno === standardCategorySno,
      );
      if (!found) {
        console.error('Selected standard category not found');
        return;
      }
      setSelectedGroup(found);
      setSelectedProductCategory(found.product_categories[0]);
      scrollToCenter(standardCategorySno);
    },
    [groups, setSelectedGroup, setSelectedProductCategory, scrollToCenter],
  );

  return (
    <Flex
      backgroundColor="bg_secondary"
      borderColor="border_tertiary"
      borderBottomWidth={1}
    >
      <ScrollView
        ref={scrollRef}
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ paddingHorizontal: 8, paddingVertical: 4 }}
      >
        {groups.map(group => {
          const isSelected =
            group.standard_category_sno === selectedGroup.standard_category_sno;
          return (
            <Flex
              key={group.standard_category_sno}
              onLayout={e => {
                const { x, width } = e.nativeEvent.layout;
                itemLayoutsRef.current.set(group.standard_category_sno, {
                  x,
                  width,
                });
              }}
              borderRadius={4}
              padding={{ horizontal: 8, vertical: 8 }}
              height={32}
              alignItems="center"
              justifyContent="center"
              onPress={() =>
                handleSelectStandardCategory(group.standard_category_sno)
              }
            >
              <Typography
                type={isSelected ? 'subtitle3' : 'body3'}
                rawColor={
                  isSelected ? Colors.content_primary : Colors.content_secondary
                }
              >
                {group.standard_category_name}
              </Typography>
            </Flex>
          );
        })}
      </ScrollView>
    </Flex>
  );
};
